import React from "react";
import InputRules from "./InputRules";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";

interface Props {
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, error?: boolean) => void;

  label?: string;
  name?: string;
  id?: string;
  className?: any;
  InputProps?: any;

  //@ts-ignore
  margin?: TextFieldProps.margin;
  //@ts-ignore
  variant?: TextFieldProps.variant;
}

class ProbabilityInput extends React.Component<Props> {

  render() {

    const { value } = this.props;
    const isValueValid = InputRules.isProbabilityValid(value);

    return (
        <TextField
            required
            type="text"
            fullWidth
            error={!isValueValid}
            helperText={isValueValid ? undefined : InputRules.DESCRIPTIONS.PROBABILITY}
            {...this.props}
        />
    );
  }
}

export default ProbabilityInput;
